import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Card, CardBody, CardHeader, Table, Button, Row, Col, CardFooter } from "reactstrap";
import { useEtim } from "../../context/ETIMContext";
import { useService } from "../../context/ServiceContext";
import SubmitButton from "../SubmitButton";
import ExportBMECatModal from "./ExportBMECatModal";
import InlineError from "../InlineError";

export default function Summary() {
  const { etim, products, etimClasses, isDirty, setIsDirty } = useEtim();
  const { etimStore } = useService();
  const [saving, setSaving] = useState(false);
  const [BMECatModalOpen, setBMECatModalOpen] = useState(false);
  const toggleBMECatModal = () => setBMECatModalOpen(!BMECatModalOpen);

  const [error, setError] = useState(null);

  const handleSave = async () => {
    try {
      setSaving(true);
      const payload = {
        seriesId: etim.seriesId,
        seriesName: etim.seriesName || etim.seriesId,
        version: etim.version,
        classETIM: etim.classEtim,
        groupedProducts: etim.groupedProducts.map((group) => ({
          commercialClassETIM: group.commercialClassETIM,
          products: group.products,
          parameterValues: group.parameterValues,
        })),
      };
      await etimStore.store(payload);
      setSaving(false);
      setIsDirty(false);
    } catch (err) {
      setError(err);
      return;
    }
  };

  const handleExportBmeCat = () => {
    setBMECatModalOpen(true);
  };

  return (
    <>
      {error ? (
        <InlineError message={error.message} onClose={() => setError(null)} />
      ) : (
        <div className="summary-container">
          <Card>
            <CardHeader>
              <FormattedMessage id="etim.summary_title" defaultMessage="ETIM Summary" />
            </CardHeader>
            <CardBody>
              <div className="table-wrapper">
                <table className="table align-items-center">
                  <thead className="thead-light">
                    <tr>
                      <th>
                        <FormattedMessage id="app.series" defaultMessage="Series" />
                      </th>
                      <th>
                        <FormattedMessage id="app.etim_class" defaultMessage="Class ETIM" />
                      </th>
                      <th>
                        <FormattedMessage id="attribute.CommercialClassETIM" defaultMessage="Commercial Class ETIM" />
                      </th>
                      <th>
                        <FormattedMessage id="app.product" defaultMessage="Product" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {etim.groupedProducts &&
                      etim.groupedProducts.map((group, index) => (
                        <tr key={index}>
                          <td>{etim.seriesName || etim.seriesId}</td>
                          <td>
                            {etimClasses.find((e) => e.value == etim.classEtim)?.label} ({etim.classEtim || "-"})
                          </td>
                          <td>{group.commercialClassETIM}</td>
                          <td className="text-wrap">
                            <ul className={`list-unstyled ${group.products.length > 10 ? "overflow-auto" : ""}`} style={group.products.length > 10 ? { maxHeight: "200px" } : {}}>
                              {group.products.map((id) => {
                                let p = products.find((x) => x.id == id);
                                return <li key={id}>{p?.name ?? "-"}</li>;
                              })}
                            </ul>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              {(!etim.groupedProducts || etim.groupedProducts.length === 0) && (
                <p className="text-muted text-center p-3">
                  <FormattedMessage id="etim.no_grouped_products" defaultMessage="No grouped products to display." />
                </p>
              )}
            </CardBody>
            <CardFooter>
              <Row className="mt-4">
                <Col md="12" className="text-right">
                  {/* <Button color="primary" onClick={handleSave} disabled={!isDirty}>
                  <FormattedMessage id="app.save" defaultMessage="Save" />
                  </Button> */}
                  <Button className="btn btn-outline-primary" onClick={handleExportBmeCat}>
                    <FormattedMessage id="etim.export_bmecat" defaultMessage="Export BMECAT" />
                  </Button>
                  <SubmitButton type="submit" onClick={handleSave} className="btn btn-outline-primary" submitting={saving ? 1 : 0} submitted={!isDirty ? 1 : 0}></SubmitButton>
                </Col>
              </Row>
            </CardFooter>
          </Card>
          <ExportBMECatModal isOpen={BMECatModalOpen} toggle={toggleBMECatModal} />
        </div>
      )}
    </>
  );
}
